export function convertCsvToSql(originalContents, isUseForOracle = false) {
    if(originalContents == null || originalContents.trim() == ""){
        return;
    }


    let result;

    result = convertProcessFacade(originalContents, isUseForOracle);

    return result;
}


function convertProcessFacade(targetContent, isUseForOracle){
    let result = {};
    let targetContentArray = targetContent.split(/\r?\n/g);

    //-----< Remove Blank Line >-----
    targetContentArray = removeBlankLines(targetContentArray);


    //-----< Return If lines is 2 or less >-----
    if(targetContentArray.length <= 1){
        return;
    }

    //-----< Set Data >-----
    let headerLine = getHeaderLine(targetContentArray);
    let dataLines  = getDataLines(targetContentArray);

    result = getSqlFormatData(headerLine, dataLines, isUseForOracle);

    return result;
}

function removeBlankLines(targetContentArray){
    let resultContentArray = targetContentArray.filter( (el)=> el.trim().length > 0);
  
    return resultContentArray;
}

function getHeaderLine(targetContentArray){
    let resultContentArray = targetContentArray[0].trim();
  
    return resultContentArray;
}

function getDataLines(targetContentArray){
    let resultContentArray = [];

    for(var i=1; i<targetContentArray.length; i++){
        let el = targetContentArray[i];
        resultContentArray.push(el)
    }

    return resultContentArray;
}

function getSqlFormatData(headerLine, dataLines, isUseForOracle){
    const NEW_LINE_CHARACTER = "\n";

    let headerContext = "";
    let bodyContext   = "";
    let footerContext = "";

    //-----------------------
    //  Set Header Context
    //-----------------------
    let headerElements = headerLine.split(",");
    if(isUseForOracle){
        headerElements = headerElements.map((el) => "\"" + el + "\"");
    }else{
        headerElements = headerElements.map((el) => "`" + el + "`");
    }

    let selectPhrase = "    " + headerElements.join(NEW_LINE_CHARACTER + "   ,");

    headerContext += "SELECT "     + NEW_LINE_CHARACTER;
    headerContext += selectPhrase  + NEW_LINE_CHARACTER;
    headerContext += "FROM " + NEW_LINE_CHARACTER;
    headerContext += "( ";


    //-----------------------
    //  Set Body Context
    //-----------------------
    let csvHeaders = headerLine.split(",");
    csvHeaders = csvHeaders.map((el) => "\"" + el + "\"");

    let dataContentsArray = [];
    dataLines.forEach(el => {
        let dta = [];

        let dataElements = el.split(","); 
        dataElements = dataElements.map((el) => "\"" + el + "\"");
        for(let i=0; i<dataElements.length; i++){
            let cell = dataElements[i] + " AS " + csvHeaders[i];
            dta.push(cell);
        }

        let dataLine = "SELECT " + dta.join(",");
        if(isUseForOracle){
            dataLine += " FROM dual";
        }

        dataContentsArray.push(dataLine);
    });

    let dataContext = dataContentsArray.join(" UNION ALL" + NEW_LINE_CHARACTER)


    bodyContext = dataContext

    //-----------------------
    //  Set Header Context
    //-----------------------
    if(isUseForOracle){
        footerContext += ") csv";
    }else{
        footerContext += ") AS csv";
    }


    //===================================
    //        Set Result Context
    //===================================
    let result = "";
    result += headerContext + NEW_LINE_CHARACTER;
    result += bodyContext   + NEW_LINE_CHARACTER;
    result += footerContext + NEW_LINE_CHARACTER;


    return result;
}
